<div class="kz-registerV2 kz-loginV2">
  <div class="kz-registerV2-container kz-loginV2-container">
    <div class="kz-registerV2-content kz-loginV2-content">
      <kz-icons name="kozikaza"></kz-icons>
      <h2 i18n="@@auth.login.title">Connexion</h2>

      <p class="other-links"><ng-container i18n="@@auth.login.no_account">No account yet ?</ng-container>&nbsp;<a [routerLink]="['', { outlets: { auth: ['authentification', 'signup']}}]" data-cy="account" i18n="@@auth.login.signup">Signup</a></p>

      <app-signin-form-lite></app-signin-form-lite>

      <div class="kz-field-buttons">
        <button type="button" kzButton buttonStyle="borderless" (click)="close()" [disabled]="submitted" i18n="@@auth.button.cancel" appGtmTrack="login_cancel">Cancel</button>
        <button type="button" (click)="save()" kzButton buttonStyle="flat" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted" data-cy="submitLogin" appGtmTrack="login_login"><span i18n="@@auth.button.login">Login</span></button>
      </div>

    </div>
    <app-legal-notice [whiteTxt]="true"></app-legal-notice>
  </div>
</div>
